document.addEventListener("DOMContentLoaded", function () {
    const canvasInstances = {};

    // Function to clear other canvases except the active one
    function clearOtherCanvases(activeCanvasId) {
        Object.keys(canvasInstances).forEach(id => {
        if (id !== activeCanvasId) {
            canvasInstances[id].clear();
            canvasInstances[id].renderAll();
        }
        });
    }

    // Function to move image carousel to first position
    function moveCarouselToPosition(dataPosition) {
        const thumbBtn = document.querySelector(
            `li[data-media-position="${dataPosition}"] button`
        );
        if (thumbBtn && thumbBtn.getAttribute('aria-current') !== 'true') {
            thumbBtn.click();
        }
    }

    // Function to get the front media for the selected color
    function getFrontMediaForSelectedColor() {
        const selectedColorInput = document.querySelector('input[name="Color"]:checked');
        if (!selectedColorInput) return null;

        const selectedColor = selectedColorInput.value;

        const mediaItems = document.querySelectorAll('.product__media-item');
        for (const item of mediaItems) {
            const media = item.querySelector('.product__media');
            if (!media) continue;
            if (media.getAttribute('data-color') === selectedColor) {
                return media;
            }
        }
        return null;
    }
  
    // Trim transparent borders from a design image — returns a cropped HTMLImageElement
    function trimDesignImage(img) {
        return new Promise((resolve) => {
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = img.width;
            tempCanvas.height = img.height;
            const ctx = tempCanvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            const { data } = ctx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
            let minX = tempCanvas.width, maxX = 0, minY = tempCanvas.height, maxY = 0;
            let hasContent = false;

            for (let y = 0; y < tempCanvas.height; y++) {
                for (let x = 0; x < tempCanvas.width; x++) {
                    if (data[(y * tempCanvas.width + x) * 4 + 3] > 10) {
                        if (x < minX) minX = x;
                        if (x > maxX) maxX = x;
                        if (y < minY) minY = y;
                        if (y > maxY) maxY = y;
                        hasContent = true;
                    }
                }
            }

            if (!hasContent) { resolve(img); return; }

            const croppedCanvas = document.createElement('canvas');
            croppedCanvas.width  = maxX - minX + 1;
            croppedCanvas.height = maxY - minY + 1;
            croppedCanvas.getContext('2d').drawImage(
                tempCanvas, minX, minY, croppedCanvas.width, croppedCanvas.height,
                0, 0, croppedCanvas.width, croppedCanvas.height
            );

            const trimmed = new Image();
            trimmed.onload = () => resolve(trimmed);
            trimmed.src = croppedCanvas.toDataURL();
        });
    }

    // Secondary trim for designs whose background is opaque (non-transparent) — finds non-white/colored content
    function trimContentDesign(img) {
        return new Promise((resolve) => {
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = img.width;
            tempCanvas.height = img.height;
            const ctx = tempCanvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const { data } = ctx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);

            let minX = tempCanvas.width, maxX = 0, minY = tempCanvas.height, maxY = 0;
            let hasContent = false;

            for (let y = 0; y < tempCanvas.height; y++) {
                for (let x = 0; x < tempCanvas.width; x++) {
                    const i = (y * tempCanvas.width + x) * 4;
                    const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
                    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
                    // Non-transparent AND not near-white background
                    if (a > 30 && luminance < 220) {
                        if (x < minX) minX = x;
                        if (x > maxX) maxX = x;
                        if (y < minY) minY = y;
                        if (y > maxY) maxY = y;
                        hasContent = true;
                    }
                }
            }

            if (!hasContent) { resolve(img); return; }

            const croppedCanvas = document.createElement('canvas');
            croppedCanvas.width  = maxX - minX + 1;
            croppedCanvas.height = maxY - minY + 1;
            croppedCanvas.getContext('2d').drawImage(
                tempCanvas, minX, minY, croppedCanvas.width, croppedCanvas.height,
                0, 0, croppedCanvas.width, croppedCanvas.height
            );

            const trimmed = new Image();
            trimmed.onload = () => resolve(trimmed);
            trimmed.src = croppedCanvas.toDataURL();
        });
    }

    // Function to load image onto the canvas
    function loadImageToCanvas(canvasId, imageId, mascotId, dataColor, designUrl, metafieldImage, maxWidthMultipler, maxHeightMultipler, designName, circularDesign) {
        let canvas = canvasInstances[canvasId];

        if (!canvas) {
            // Initialize the canvas only if it hasn't been initialized
            canvas = new fabric.Canvas(canvasId);
            canvasInstances[canvasId] = canvas; // Store the canvas instance
        }

        // Clear the canvas to remove the previous image
        canvas.clear();
        canvas.renderAll();

        const shirtElement = document.getElementById(imageId);
        const mascotElement = document.getElementById(mascotId);

        const activeElement = document.querySelector('.product__media-item.is-active');
        const customizationDataElement = activeElement.querySelector('#customization-data');
        let customizationData = customizationDataElement.getAttribute('data-customization');
        customizationData = customizationData.replace(/'/g, '"'); // Format JSON

        const customizationJsonElement = activeElement.querySelector('#customization-id-data');
        const customizationJsonData = customizationJsonElement.getAttribute('data-customization-id');
        const customizationJson = JSON.parse(customizationJsonData);
        const designAlignment = customizationJson.design_alignment;
        const designScalingMethod = customizationJson.design_scaling_method;

        let customizationLocation = [];
        try {
            customizationLocation = JSON.parse(customizationData);
        } catch (e) {
            console.error("Error parsing customization data:", e);
            return;
        }

        const designInfo = customizationLocation['design_info'][0];

        const isMobile = window.innerWidth <= 749;

        const canvasMaxWidth = isMobile ? 375 : 715;
        const canvasMaxHeight = isMobile ? 375 : 715;

        const productImage = new Image();
        productImage.crossOrigin = 'anonymous';

        let canvasImage;
        if (metafieldImage) {
            canvasImage = metafieldImage;
        } else {
            canvasImage = shirtElement.src;
        }

        productImage.src = canvasImage;

        productImage.onload = function () {
            let productImageWidth = productImage.width;
            let productImageHeight = productImage.height;

            if (productImageWidth > canvasMaxWidth || productImageHeight > canvasMaxHeight) {
                const scale = Math.min(canvasMaxWidth / productImageWidth, canvasMaxHeight / productImageHeight);
                productImageWidth *= scale;
                productImageHeight *= scale;
            }

            canvas.setWidth(productImageWidth);
            canvas.setHeight(productImageHeight);

            const productInstance = new fabric.Image(productImage, {
                left: 0,
                top: 0,
                angle: 0,
                selectable: false,
                evented: false
            });

            productInstance.scaleToWidth(productImageWidth);
            productInstance.scaleToHeight(productImageHeight);

            canvas.add(productInstance);
            canvas.renderAll();

            const designImage = new Image();
            designImage.crossOrigin = 'anonymous';
            designImage.src = designUrl || mascotElement.src;

            if ( designName !== "blank" ) {
                designImage.onload = async function () {
                const origW = designImage.naturalWidth || designImage.width;
                const origH = designImage.naturalHeight || designImage.height;
                let finalDesignImage = await trimDesignImage(designImage).catch(() => designImage);
                const transparentTrimHappened = finalDesignImage.width < origW || finalDesignImage.height < origH;
                const productType = (customizationDataElement.getAttribute('data-product-type') || '').toLowerCase();
                const singleLineEmbroidery = ['emb01', 'emb02', 'emb03', 'emb04'];
                if ((productType === 'towels' && !transparentTrimHappened) || singleLineEmbroidery.includes(designName.toLowerCase())) {
                    finalDesignImage = await trimContentDesign(finalDesignImage).catch(() => finalDesignImage);
                }

                let designImageWidth = finalDesignImage.width;
                let designImageHeight = finalDesignImage.height;
                let designImageInitialWidth = finalDesignImage.width;
                let designImageInitialHeight = finalDesignImage.height;
                let centerX = designInfo.designCenter;
                let designYPercent = 1 - designInfo.designHeight;
        
                let boundingBoxWidth = productImageWidth * designInfo.MaxWidth * maxWidthMultipler;
                let boundingBoxHeight = productImageHeight * designInfo.MaxHeight * maxHeightMultipler;
                let boundingBoxCenterX = productImageWidth * centerX;
                
                let boundingBoxTop = productImageHeight * designYPercent;
                let boundingBoxBottom = boundingBoxTop + boundingBoxHeight;
                let boundingBoxLeft = boundingBoxCenterX - (boundingBoxWidth / 2);
                let boundingBoxRight = boundingBoxCenterX + (boundingBoxWidth / 2);
                let boundingBoxMiddle = boundingBoxTop + (boundingBoxHeight / 2);

                let mascotScale;
                    
                // if (designScalingMethod === "fit" || designScalingMethod === "") {
                if (designScalingMethod === "fit" || designScalingMethod === "" || (designScalingMethod === "hypotenuse" && circularDesign) || (designScalingMethod === "hypotenuse" && !circularDesign && productType === 'towels')) {
                    mascotScale = Math.min(boundingBoxWidth / designImageWidth, boundingBoxHeight / designImageHeight);
                    if (productType === 'towels') {
                        // Dense designs that fill both bounding box dimensions get 15% padding
                        // Wide/sparse designs that only fill one dimension are left unchanged
                        const fillW = (designImageWidth * mascotScale) / boundingBoxWidth;
                        const fillH = (designImageHeight * mascotScale) / boundingBoxHeight;
                        const trimAreaRatio = (designImageWidth * designImageHeight) / (origW * origH);
                        if (trimAreaRatio > 0.85 && fillW > 0.90 && fillH > 0.98) {
                            mascotScale *= 0.85;
                        }
                        console.log('[Towel]', designName, {
                            trimmedImgW: Math.round(designImageWidth), trimmedImgH: Math.round(designImageHeight),
                            origW, origH,
                            boxW: Math.round(boundingBoxWidth), boxH: Math.round(boundingBoxHeight),
                            trimAreaRatio: trimAreaRatio.toFixed(3),
                            fillW: fillW.toFixed(2), fillH: fillH.toFixed(2),
                            scale: mascotScale.toFixed(4),
                            finalW: Math.round(designImageWidth * mascotScale),
                            finalH: Math.round(designImageHeight * mascotScale)
                        });
                    }
                    
                } else if (designScalingMethod === "hypotenuse") {
                    const hypotenuse = Math.sqrt((boundingBoxHeight ** 2) + (boundingBoxWidth ** 2));
                    const maxHypotenuse = Math.min(boundingBoxHeight, boundingBoxWidth);

                    if (hypotenuse > maxHypotenuse) {
                        const circleAdj = maxHypotenuse / hypotenuse;
                        mascotScale = Math.min(boundingBoxWidth / designImageWidth, boundingBoxHeight / designImageHeight) * circleAdj;
                    } else {
                        mascotScale = Math.min(boundingBoxWidth / designImageWidth, boundingBoxHeight / designImageHeight);
                    }
                } else {
                    mascotScale = Math.min(boundingBoxWidth / designImageWidth, boundingBoxHeight / designImageHeight);
                }

                designImageHeight = designImageInitialHeight * mascotScale;
                designImageWidth = designImageInitialWidth * mascotScale;
                
                let mascotLeft;
                let mascotTop;

                // Calculate mascotLeft based on alignment
                if (designAlignment.includes("left")) {
                    mascotLeft = boundingBoxLeft;
                } else if (designAlignment.includes("right")) {
                    mascotLeft = boundingBoxRight - designImageWidth;
                } else { // Center or default
                    mascotLeft = boundingBoxCenterX - (designImageWidth / 2);
                }

                // Calculate mascotTop — center trimmed design vertically, respect bottom alignment
                if (designAlignment.includes("bottom")) {
                    mascotTop = boundingBoxBottom - designImageHeight;
                } else {
                    mascotTop = boundingBoxMiddle - (designImageHeight / 2);
                }

                const newMascotInstance = new fabric.Image(finalDesignImage, {
                    left: mascotLeft,
                    top: mascotTop,
                    angle: 0,
                    selectable: false,
                    evented: false,
                });

                newMascotInstance.scale(mascotScale);
                canvas.add(newMascotInstance);
                canvas.renderAll();
                };
            }
        };
    }
  
    // Reinitialize on color swatch clicks
    document.querySelectorAll('.color-swatch-box ').forEach(swatch => {
      swatch.addEventListener('click', function () {
          // Reset team-store-designs active to the first design
          const teamStoreDesigns = document.querySelectorAll('.team-store-design');
          teamStoreDesigns.forEach(design => design.classList.remove('active'));

          // Close lightbox on click
          const lightbox = document.querySelectorAll('#product-lightbox');
          lightbox.forEach(el => el.style.display = 'none');

          const customizable = this.getAttribute('data-customizable');    
          const teamstoresDesignContainer = document.querySelector('.teamstore-designs-container');
          const teamstoresDesignWrapper = document.querySelector('.team-store-designs-wrapper');
          const gtpProductFormButtons = document.querySelector('.product-form__gtp-buttons');

          let designName = 'blank';
          
          if (customizable === 'true') {
              teamstoresDesignWrapper.style.display = 'block';
              gtpProductFormButtons.style.display = 'flex';
               if (teamstoresDesignContainer) {
                  teamstoresDesignContainer.style.border = '1px solid #000';
              }
          } else {
                // gtpProductFormButtons.style.display = 'none';
              if (teamstoresDesignWrapper) {
                  teamstoresDesignWrapper.style.display = 'none';
              }
              if (teamstoresDesignContainer) {
                  teamstoresDesignContainer.style.border = 'none';
              }
          }
  
          setTimeout(() => {
              const designImages = document.querySelectorAll('.team-store-designs img');
              const selectedColor = document.querySelector('input[name="Color"]:checked');
              const sku_thread_color = selectedColor.getAttribute('data-sku-thread-color');

              designImages.forEach(img => {
                  const imgSrc = img.getAttribute('src');
                  img.setAttribute('src', imgSrc.replace(/_(white|black)(\.png)/i, `_${sku_thread_color}$2`));
              });

              const activeDesign = document.querySelector(".team-store-design.active");
              if (!activeDesign) {
                  return;
              }
              const activeimgElement = activeDesign.querySelector("img");
              const activeimgSrc = activeimgElement.getAttribute("src");
              const maxWidthMultipler = activeDesign.getAttribute('data-max-width-modifier')
              const maxHeightMultipler = activeDesign.getAttribute('data-max-height-modifier')
              const activeItems = document.querySelector('.product__media-item.grid__item.slider__slide.is-active .product__media');
              const circularDesign = activeDesign.getAttribute('data-circular-design')
          
              const dataPosition = activeItems.getAttribute('data-position');
              const dataColor = activeItems.getAttribute('data-color');
  
              const currentCanvasId = `canvas-${dataPosition}`;
              const imageId = `product_image-${dataPosition}`;
              const mascotId = `mascot_image-${dataPosition}`;
  
              if (currentCanvasId != "canvas-null") {
                  const mascotElement = document.getElementById(mascotId);
                  const selectedMascotId = activeimgSrc;
                  mascotElement.src = selectedMascotId;
  
                  let designUrl = activeimgSrc;
                  let metafieldImage = this.getAttribute('data-teamstore-image');
                  const selectedColor = document.querySelector('input[name="Color"]:checked');
                  const sku_thread_color = selectedColor.getAttribute('data-sku-thread-color');
  
                  // Replace the _white or _black thread-color suffix before .png with sku_thread_color
                  designUrl = designUrl.replace(/_(white|black)(\.png)/i, `_${sku_thread_color}$2`);

                  if (customizable === 'true') {
                    loadImageToCanvas(currentCanvasId, imageId, mascotId, dataColor, designUrl, metafieldImage, maxWidthMultipler, maxHeightMultipler, designName, circularDesign);
                }
              }

          }, 100); // Delay to ensure DOM updates
      });
    });
  
    // Handle click events dynamically
    document.querySelectorAll('.team-store-design img').forEach(img => {
        img.addEventListener('click', function (event) {
            event.preventDefault();
            const activeDesign = this.closest('.team-store-design').getAttribute('data-image');
            const circularDesign = this.closest('.team-store-design').getAttribute('data-circular-design')
            const maxWidthMultipler = this.closest('.team-store-design').getAttribute('data-max-width-modifier')
            const maxHeightMultipler = this.closest('.team-store-design').getAttribute('data-max-height-modifier')
            const designName = this.closest('.team-store-design').getAttribute('data-tsdesign-name');
            
            document.querySelectorAll('.color-swatch-box').forEach(el => {
                el.setAttribute('data-active-design', activeDesign);
            });
  
            document.querySelectorAll('.team-store-design').forEach(el => {
                el.classList.remove('active');
            });
  
            this.closest('.team-store-design').classList.add('active');
  
            document.querySelectorAll('.product__media-item').forEach((activeMediaItem) => {
                if (activeMediaItem.classList.contains('is-active')) {
                      const mediaDiv = activeMediaItem.querySelector('.product__media');
                      // const dataPosition = mediaDiv.getAttribute('data-position');
                      // To make the logo render only on the front media, use the function to get front media
                      const frontMedia = getFrontMediaForSelectedColor();
                      let dataPosition;
                      if (!frontMedia) {
                        // To make the logo work on any canvas as fallback
                        dataPosition = mediaDiv.getAttribute('data-position');
                      } else {
                        dataPosition = frontMedia.getAttribute('data-position');
                      }
                      const dataColor = mediaDiv.getAttribute('data-color');
  
                      // Get the checked input radio
                      const selectedColor = document.querySelector('input[name="Color"]:checked');
                      const sku_thread_color = selectedColor.getAttribute('data-sku-thread-color');
  
                      const currentCanvasId = `canvas-${dataPosition}`;
                      const imageId = `product_image-${dataPosition}`;
                      const mascotId = `mascot_image-${dataPosition}`;
  
                      if (currentCanvasId != "canvas-null") {
                          const mascotElement = document.getElementById(mascotId);
                          const selectedMascotId = this.src;

                          mascotElement.src = selectedMascotId;
  
                          let designUrl = activeDesign;
                          // Replace the _white or _black thread-color suffix before .png with sku_thread_color
                          designUrl = designUrl.replace(/_(white|black)(\.png)/i, `_${sku_thread_color}$2`);
  
                          let dataTeamstoreImage;
                          if (selectedColor) {
                            const label = document.querySelector(`label[for="${selectedColor.id}"]`);
                            // Get the `data-teamstore-image` attribute value
                            dataTeamstoreImage = label?.getAttribute('data-teamstore-image');
                          }
              
                          let metafieldImage = dataTeamstoreImage;
                          moveCarouselToPosition(dataPosition);
                          clearOtherCanvases(currentCanvasId);
                          loadImageToCanvas(currentCanvasId, imageId, mascotId, dataColor, designUrl, metafieldImage, maxWidthMultipler, maxHeightMultipler, designName, circularDesign);
                      }
                  }
              });
            
            // Show the product image in a lightbox
            const selectedColor = document.querySelector('input[name="Color"]:checked');
            const productImageLabel = document.querySelector(`label[for="${selectedColor.id}"]`);
            const dataTeamstoreImage = productImageLabel?.getAttribute('data-teamstore-image');

            // Select the lightbox within the currently active product media item using ID selectors
            const activeMediaItem = document.querySelector('.product__media-item.is-active');
            const lightbox = activeMediaItem ? activeMediaItem.querySelector('#product-lightbox') : null;
            const lightboxImg = activeMediaItem ? activeMediaItem.querySelector('#lightbox-img') : null;

            if (dataTeamstoreImage && lightbox && lightboxImg) {
              lightboxImg.src = dataTeamstoreImage;
              lightbox.style.display = 'flex';
            }
          });
    });

    // On page load, sync design tile images to the initially checked color's thread color.
    // Liquid renders all design tiles using the last color in the loop (not the selected variant's
    // color), so this corrects the mismatch when a customer lands via search with a pre-selected variant.
    (function applyInitialThreadColor() {
        const selectedColor = document.querySelector('input[name="Color"]:checked');
        if (!selectedColor) return;
        const skuThreadColor = selectedColor.getAttribute('data-sku-thread-color');
        if (!skuThreadColor) return;
        document.querySelectorAll('.team-store-designs img').forEach(function(img) {
            const src = img.getAttribute('src');
            if (src) {
                img.setAttribute('src', src.replace(/_(white|black)(\.png)/i, '_' + skuThreadColor + '$2'));
            }
        });
        document.querySelectorAll('a.team-store-design').forEach(function(link) {
            const dataImage = link.getAttribute('data-image');
            if (dataImage) {
                link.setAttribute('data-image', dataImage.replace(/_(white|black)(\.png)/i, '_' + skuThreadColor + '$2'));
            }
        });
    })();
});

// Close lightbox on click
const closeBtn = document.querySelector('#lightbox-close');
if (closeBtn) {
    closeBtn.onclick = function() {
        const teamStoreDesigns = document.querySelectorAll('.team-store-design');
        const lightbox = document.querySelectorAll('#product-lightbox');
        teamStoreDesigns.forEach(design => design.classList.remove('active'));
        lightbox.forEach(el => el.style.display = 'none');

        const oc_box = document.querySelector('.oc-customization');
        if (oc_box) {
            oc_box.style.border = 'none';
        }

        // Reset error message in product-form.js and re-enable add to cart button
        const productForm = document.querySelector('product-form');
        if (productForm && typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage();
            if (productForm.submitButton) {
                productForm.submitButton.removeAttribute('aria-disabled');
                productForm.submitButton.classList.remove('loading');
            }
            const spinner = productForm.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.add('hidden');
        }
    };
}
